import React from "react";
import { LOGO, BOOKING_URL } from "../lib/i18n";

export default function Nav({ lang, setLang, t }) {
  const scrollToChat = () => {
    document.getElementById("chat")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-40 bg-paper/85 backdrop-blur-md border-b border-rule"
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 md:px-10 lg:px-16 h-16 flex items-center justify-between gap-3">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
          aria-label="Nettpilot home"
        >
          <img
            src={LOGO}
            alt="Nettpilot"
            className="h-9 w-auto opacity-90 group-hover:opacity-100 transition-opacity"
          />
          <span className="hidden sm:inline font-mono text-[11px] tracking-[0.18em] uppercase text-mist">
            / {t.nav.tagline}
          </span>
        </a>

        <nav className="flex items-center gap-2 md:gap-4">
          <div
            data-testid="lang-toggle"
            className="shrink-0 font-mono text-[11px] tracking-widest border border-rule rounded-full overflow-hidden flex"
          >
            <button
              data-testid="lang-no"
              onClick={() => setLang("no")}
              className={`px-3 py-1.5 transition-colors ${
                lang === "no" ? "bg-ink text-paper" : "text-mist hover:text-ink"
              }`}
            >
              NO
            </button>
            <button
              data-testid="lang-en"
              onClick={() => setLang("en")}
              className={`px-3 py-1.5 transition-colors ${
                lang === "en" ? "bg-ink text-paper" : "text-mist hover:text-ink"
              }`}
            >
              EN
            </button>
          </div>

          <a
            data-testid="nav-blog-link"
            href="/blog"
            className="hidden sm:inline-flex font-mono text-[11px] tracking-widest uppercase px-3 py-2 text-ink hover:text-ember transition-colors"
          >
            {lang === "no" ? "Blogg" : "Blog"}
          </a>

          <button
            data-testid="nav-chat-btn"
            onClick={scrollToChat}
            className="hidden md:inline-flex font-mono text-[11px] tracking-widest uppercase px-4 py-2 border border-rule hover:border-ink rounded-full transition-colors"
          >
            {t.nav.chat}
          </button>

          <a
            data-testid="nav-book-btn"
            href={BOOKING_URL}
            target="_blank"
            rel="noreferrer"
            className="shrink-0 whitespace-nowrap font-mono text-[11px] tracking-widest uppercase px-3 sm:px-4 py-2 bg-ink text-paper rounded-full hover:bg-ember transition-colors"
          >
            {t.nav.book}<span className="hidden sm:inline"> →</span>
          </a>
        </nav>
      </div>
    </header>
  );
}
